// extracted by mini-css-extract-plugin
export default {"root":"PreviewMobileWrapper_root__2YzZi","toolbar":"PreviewMobileWrapper_toolbar__3my7l"};